module.exports = __webpack_public_path__ + "media/packs/src/assets/images/notification-2fba1e6170c78be2401fe55c1f31d186.svg";